
import {
  convertDecimalWithComma,
  ellipsisString,
  formatDateNormal,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import { ShipmentBooking } from "@/domain/entities/ShipmentBooking";
import { Options, prop, Vue } from "vue-class-component";
import copy from "copy-text-to-clipboard";
import mapProductTypeName from "@/app/infrastructures/misc/common-library/ProductTypeNameMapper";
import Notification from "@/app/ui/components/notification/index.vue";
import { ListPickupV2Controller } from "@/app/ui/controllers/ListPickupV2Controller";
import { ListSttRequestPickupRequest } from "@/data/payload/api/ListPickupV2Request";
import { Entities } from "@/domain/entities/ResponsePayload";
import { Pagination } from "@/domain/entities/Pagination";
import { debounce } from "@/app/infrastructures/misc/common-library/Debounce";
import { MainAppController } from "@/app/ui/controllers/MainAppController";

class Props {
  modelValue = prop<boolean>({ default: false, type: Boolean, required: true });
  bkdCount = prop<number>({ default: 0, type: Number, required: true });
}

@Options({
  components: {
    Notification
  },
  watch: {
    modelValue(val: boolean) {
      if (val) {
        this.init();
      }
    }
  }
})
class Modalsttpickuplist extends Vue.with(Props) {
  get visible() {
    return this.modelValue;
  }
  set visible(val: boolean) {
    this.$emit("update:modelValue", val);
  }
  onClose() {
    this.visible = false;
  }

  init() {
    this.onRequest();
  }

  //Filter Search
  onSearch = debounce((value: string) => {
    this.params.search = value;

    this.listSttData.pagination.page = 1;
    this.onRequest();
  });

  get columnsOne() {
    return [
      {
        key: "actionable_column",
        name: `<div class='flex flex-col leading-5 justify-start'>
                <span>
                  ${this.$t("pickupV2.modalSttPickupList.column.sttNo")}
                </span>
                <span class='text-gray-lp-600 font-normal'>
                  ${this.$t("pickupV2.modalSttPickupList.column.shipmentNo")}
                </span>
              </div>`,
        styleHead: "w-60 text-left whitespace-no-wrap",
        styleBody: "text-red-lp-200 text-center",
        render: (item: ShipmentBooking) => {
          return `
            <div class="flex flex-col leading-5">
              <div class="flex items-center space-x-1">
                <div class='text-left text-red-lp-100 underline'>
                  ${item.sttNo}
                </div>
                ${
                  item.sttIsCod
                    ? item.sttIsDfod
                      ? `<img src="${require("@/app/ui/assets/svg/new-dfod.svg")}" class="h-2.5" />`
                      : `<img src="${require("@/app/ui/assets/svg/new-cod.svg")}" class="h-2.5" />`
                    : ""
                }
              </div>
              ${
                item.sttShipmentId
                  ? `<div class="text-black-lp-300">${item.sttShipmentId}</div>`
                  : ""
              }
            </div>
        `;
        },
        showButton: () => true,
        icon: "copy-clipboard",
        iconStyle: "ml-1",
        iconColor: "red-lp-100",
        onClickValue: (item: ShipmentBooking) => {
          const result = copy(item.sttNo);
          if (result) {
            this.setNotification();
          }
        },
        iconTooltip: () => this.$t("pickupV2.modalSttPickupList.copyStt")
      }
    ];
  }

  get columnsTwo() {
    return [
      {
        name: this.$t("pickupV2.modalSttPickupList.column.lastStatus"),
        styleHead: "w-40 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="text-black-lp-300 flex">
                    <div class="rounded capitalize px-2 py-0 ${this.mapLastStatusColor(
                      item.sttLastStatusId
                    )}">
                        ${item.sttLastStatusId}
                    </div>
                  </div>`;
        },
        toolTip: (item: ShipmentBooking) => {
          if (item.sttLastStatusId === "CODREJ") {
            return `<div class='flex text-black-lp-300 text-12px max-w-xs'>${item.dexCodrejReason}</div>`;
          }
          if (item.sttLastStatusId === "DEX") {
            return `
              <div class="text-xs">
                <h5 class="text-gray-lp-300 font-semibold">Percobaan DEX ke ${item.totalSttDex}</h5>
                <p class="text-gray-lp-600">${item.dexCodrejReason}</p>
              </div>
            `;
          }
        }
      },
      {
        name: this.$t("pickupV2.modalSttPickupList.column.destinationCity"),
        styleHead: "w-40 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="break-all text-black-lp-300 line-clamp-2" title="${item.sttDestinationCity} - ${item.sttDestinationCityName}">${item.sttDestinationCity} - ${item.sttDestinationCityName}</div>`;
        }
      }
    ];
  }

  get columnThree() {
    return [
      {
        name: `<div class='flex flex-col leading-5 justify-start'>
                <span>
                  ${this.$t("pickupV2.modalSttPickupList.column.productType")}
                </span>
                <span class='text-gray-lp-600 font-normal'>
                  ${this.$t("pickupV2.modalSttPickupList.column.chargeableWeight")}
                </span>
              </div>`,
        styleHead: "w-56 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="flex flex-col leading-5">
                    <div class="capitalize text-black-lp-300">
                      ${mapProductTypeName(item.sttProductType)}
                    </div>
                    <div class='text-gray-lp-600 font-normal'>
                      ${convertDecimalWithComma(item.sttChargeAbleWeight, 2)} kg
                    </div>
                  </div>`;
        }
      },
      {
        name: this.$t("pickupV2.modalSttPickupList.column.createdAt"),
        styleHead: "w-64 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="text-black-lp-300">
                    ${formatDateNormal(
                      item.sttCreatedAt,
                      "DD MMMM YYYY, HH:mm"
                    )}
                    </div>
                    <div class="capitalize text-gray-lp-500">
                    ${ellipsisString(item.sttCreatedName || "-", 30)}
                  </div>`;
        }
      },
      {
        name: this.$t("pickupV2.modalSttPickupList.column.bookedFor"),
        styleHead: "w-64 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="text-black-lp-300 line-clamp-2">${item.sttBookedForName ||
            "-"}</div>`;
        },
        vtooltip: (item: ShipmentBooking) => item.sttBookedForName
      }
    ];
  }

  // Table
  get columns() {
    return [...this.columnsOne, ...this.columnsTwo, ...this.columnThree];
  }

  notification = false;
  setNotification() {
    this.notification = false;

    setTimeout(() => {
      this.notification = true;
    }, 10);
  }

  // mapping last status color
  mapLastStatusColor(status: string): string {
    const uppercaseStatus = status.toUpperCase();
    if (this.checkLastStatusBlueColor(uppercaseStatus))
      return "bg-blue-lp-600 text-blue-lp-700";
    if (this.checkLastStatusRedColor(uppercaseStatus))
      return "bg-red-lp-1300 text-red-lp text-red-lp-510";
    return "bg-gray-lp-1400 text-gray-lp-300";
  }

  checkLastStatusBlueColor(status: string): boolean {
    return [
      "CNX",
      "POD",
      "RTS",
      "CLAIM",
      "CI",
      "RTSHQ",
      "STT ADJUSTED POD",
      "REROUTE"
    ].includes(status);
  }

  checkLastStatusRedColor(status: string): boolean {
    return [
      "DEX",
      "SCRAP",
      "SHORTLAND",
      "MIS-ROUTE",
      "CODREJ",
      "MISSING",
      "DAMAGE",
      "NOT RECEIVE",
      "NOT RECEIVED",
      "MISBOOKING",
      "REJECTED"
    ].includes(status);
  }

  get isErrorList() {
    return !this.listSttData.data.length;
  }

  get isEmpty() {
    return !this.params.search && !this.listSttData.data.length;
  }

  // table
  listSttData = new Entities(false, 200, "", new Pagination(1, 10), []);
  params = new ListSttRequestPickupRequest();

  get pagination() {
    return this.listSttData.pagination;
  }

  isLoading = false;

  async onRequest() {
    try {
      this.isLoading = true;
      this.listSttData.data = [];
      MainAppController.closeErrorMessage();

      this.listSttData = await ListPickupV2Controller.getCargoTransportType(
        new ListSttRequestPickupRequest({
          ...this.params,
          page: this.pagination.page,
          limit: this.pagination.limit
        })
      );
      this.params.page = this.listSttData.pagination.page;
      this.params.limit = this.listSttData.pagination.limit;
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Gagal mengambil data STT", this.onRequest)
      );
    } finally {
      this.isLoading = false;
    }
  }

  get copyStyles() {
    return {
      background: "bg-gray-lp-300",
      text: "text-white",
      message: this.$t("pickupV2.modalSttPickupList.copiedStt"),
      width: "w-300px"
    };
  }
}

export default Modalsttpickuplist;
